<template>
  <div class="main-content">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <div class="card-title">
              {{ title }}
            </div>
          </div>
          <hr style="margin-top: -4px">
          <div class="col-md-12">
            <component
              :is="formComponent"
              v-if="entity"
              :value="entity"
              :errors="errors"
            />
            <div class="block text-right mb-1">
              <router-link
                :to="backRoute"
                class="btn btn-back"
              >
                <i class="fa fa-arrow-left" /> {{ $t('common.back') }}
              </router-link>
              <a
                v-if="$hasAbility('envolvido.gerenciar')"
                class="btn btn-add ml-1"
                @click="save"
              >
                {{ $t('common.save') }}
                <i class="fa fa-save" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InvolvedVehicleForm from '../../components/involved/InvolvedVehicleForm'
import InvolvedObjectForm from '../../components/involved/InvolvedObjectForm'
import InvolvedPropertyForm from '../../components/involved/InvolvedPropertyForm'
import InvolvedPhoneForm from '../../components/involved/InvolvedPhoneForm'
import { ENTITY_DEFAULTS } from './entityFields'

const FORMS = {
  vehicle: InvolvedVehicleForm,
  object: InvolvedObjectForm,
  property: InvolvedPropertyForm,
  phone: InvolvedPhoneForm,
}

export default {
  name: 'InvolvedEntityForm',
  data() {
    return { entity: null, errors: {} }
  },
  computed: {
    type() {
      return this.$route.params.type
    },
    id() {
      return this.$route.params.id
    },
    backRoute() {
      return { path: '/involveds', query: { tab: this.type } }
    },
    formComponent() {
      return FORMS[this.type]
    },
    title() {
      const prefix = this.id ? 'edit' : 'new'
      return this.$t(`involved.crud.entities.${prefix}${this.type.charAt(0).toUpperCase()}${this.type.slice(1)}`)
    },
  },
  created() {
    if (!ENTITY_DEFAULTS[this.type]) {
      this.$router.replace('/involveds')
      return
    }
    if (this.id) this.load()
    else this.entity = ENTITY_DEFAULTS[this.type]()
  },
  methods: {
    load() {
      this.$loading(true)
      this.$http
        .get(`${this.$store.state.api}involved_entities/${this.type}/${this.id}`)
        .then(({ data }) => {
          this.entity = { ...ENTITY_DEFAULTS[this.type](), ...data.data }
        })
        .catch(error => this.$message(null, error.response?.data?.message || error.response?.data, 'error'))
        .finally(() => this.$loading(false))
    },
    save() {
      const base = `${this.$store.state.api}involved_entities/${this.type}`
      this.$loading(true)
      const request = this.id ? this.$http.put(`${base}/${this.id}`, this.entity) : this.$http.post(base, this.entity)
      request
        .then(() => {
          this.$message(this.$t('involved.messages.successTitle'), this.$t('involved.messages.saveSuccess'), 'success')
          this.$router.push(this.backRoute)
        })
        .catch(error => {
          const data = error.response?.data
          this.errors = data?.errors || {}
          const first = data?.errors ? Object.values(data.errors)[0][0] : data?.message || data
          this.$message(null, first, 'error')
        })
        .finally(() => this.$loading(false))
    },
  },
}
</script>
